import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

const footerLinks = [
  { label: "About", to: "/about" },

  { label: "Contact", to: "/contact" },
  { label: "Terms", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Cookie Policy", to: "/cookies" },
  { label: "FAQs", to: "/faqs" },
  {
    label: "Delivery",
    to: "/shipping",
  },
  { label: "Returns", to: "/returns" },
];

function FooterLink({ item, onNavigate }) {
  if (item.href) {
    return (
      <a href={item.href} target="_blank" rel="noopener noreferrer">
        {item.label}
      </a>
    );
  }

  return (
    <Link to={item.to} onClick={onNavigate}>
      {item.label}
    </Link>
  );
}

function Footer() {
  const currentYear = new Date().getFullYear();

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-inner">
        <div className="footer-top">
          <nav className="footer-links-column" aria-label="Footer navigation">
            <ul className="footer-links">
              {footerLinks.map((item) => (
                <li key={item.label}>
                  <FooterLink item={item} onNavigate={toTop} />
                </li>
              ))}
            </ul>
          </nav>

          <section
            className="footer-contact"
            aria-labelledby="footer-contact-title"
          >
            <h2 id="footer-contact-title">Contact</h2>
            <address>
              <a href="mailto:globe@ioomparade.online">
                globe@ioomparade.online
              </a>
              <span>Hong Kong SAR</span>
            </address>
          </section>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <small>
              Copyright © {currentYear},{" "}
              <Link to="/" onClick={toTop}>
                ioomparade
              </Link>
              .
            </small>
          </div>
          <div className="footer-payments" aria-label="Supported payment methods">
            <span>Visa</span>
            <span>Mastercard</span>
            <span>American Express</span>
            <span>UnionPay</span>
            <span>JCB</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
